//获取用户信息
const getUserInfoByIdUrl = `/healthhubApi/userInfo/wx/getOpenIdByCodeAndOrg`;

export { getUserInfoByIdUrl };
